module.exports = __webpack_public_path__ + "img/whats-app.8eb29c0.svg?v=1764327952164";